<template>
  <v-container fluid>
    <v-row class="mt-0 mb-2" justify="space-between" no-gutters>
      <v-col cols="12" md="4">
        <v-card class="py-3 px-4 vcard_area">
          <v-row>
            <v-col cols="12" md="7">
              <div class="text-h1 mb-2">Distribuidores</div>
              <div class="text text--thin mb-2">Adicione novos distribuidores</div>
              <v-btn @click="dialogNovo = true" color="primary" class="mt-1"><v-icon class="mr-1">batch_prediction</v-icon>Novo distribuidor</v-btn>
            </v-col>
            <v-col cols="12" md="5">
              <div class="icon_area" :class="$vuetify.theme.dark ? 'dark_area' : 'white_area'">
                <v-icon>add</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="dados"
      disable-sort
      :server-items-length="total"
      :options.sync="options"
      :search="search"
      loading-text="Carregando... Por favor aguarde"
      :loading="carregando"
      class="elevation-1 base_table mt-4"
      :footer-props="{
        itemsPerPageOptions: [5,10,15,20,25,50,100],
        showFirstLastPage: true,
        firstIcon: 'skip_previous',
        lastIcon: 'skip_next',
        prevIcon: 'chevron_left',
        nextIcon: 'chevron_right'
      }"
      :header-props="{
        sortIcon: 'north',
      }"
    >
      <template v-slot:top>
        <v-row no-gutters align="center" justify="space-between">
          <div class="py-2 px-2">
            <v-form @submit.prevent="applyFilter()">
              <v-text-field
                clearable
                hide-details=""
                clear-icon="close"
                v-model="search"
                outlined
                label="Busca"
                @click:clear="limparBusca()"
              ></v-text-field>
            </v-form>
          </div>
          <div>
            <v-menu
              bottom
              center
              offset-y
              max-height="400"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on">
                  Exportar
                  <v-icon>arrow_drop_down</v-icon>
                </div>
              </template>
              <v-list>
                <v-list-item @click="exportXls()">
                  <v-list-item-icon class="mr-1">
                    <v-icon color="primary">receipt_long</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Exportar para XLS</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-row>
      </template>
      <template v-slot:item.users="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" @click="openUsuarios(item)" color="primary" class="ml-2">
            group
          </v-icon>
        </template>
        <span>Usuários</span>
      </v-tooltip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row no-gutters align="center" justify="center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openDistribuidor(item)" color="primary" class="mr-2" :disabled="salvando">
                edit
              </v-icon>
            </template>
            <span>Editar distribuidor</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                delete
              </v-icon>
            </template>
            <span>Excluir distribuidor</span>
          </v-tooltip>
        </v-row>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="900px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{distribuidor.uuid_dis_id ? 'Editar' : 'Novo'}} distribuidor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formDistribuidor">
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="distribuidor.dis_nome"
                autofocus
                label="Razão social*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="distribuidor.dis_nome_fantasia"
                label="Nome fantasia*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field-cnpj
                outlined
                label="CNPJ*"
                required=""
                :rules="[rules.required]"
                v-model="distribuidor.dis_cnpj"
                v-bind:properties="{
                  readonly: false,
                  disabled: salvando,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                  loading: salvando
                }"
                v-bind:options="{
                  outputMask: '##############',
                  empty: null,
                  applyAfter: false,
                }"
              ></v-text-field-cnpj>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field-cep
                v-model="distribuidor.dis_cep"
                label="CEP*"
                :rules="[rules.required]"
                :loading="loadingCep || salvando"
                :disabled="loadingCep || salvando"
                @change="searchCep(distribuidor.dis_cep)"
                v-bind:properties="{
                  disabled: false,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                }"
                v-bind:options="{
                  outputMask: '########',
                  empty: null,
                  applyAfter: false,
                }"
              />
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                v-model="distribuidor.dis_uf"
                autocomplete="off"
                :items="estados"
                :rules="[rules.required]"
                :loading="salvando || loadingEstados || loadingCep"
                :disabled="salvando || loadingEstados || loadingCep"
                label="Estado*"
                append-icon="expand_more"
                outlined
                @change="filterCidade(distribuidor.dis_uf)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                autocomplete="off"
                v-model="distribuidor.dis_cidade"
                :items="cidadesFiltradas"
                :loading="salvando || loadingCidades || loadingCep"
                :disabled="salvando || loadingCidades || loadingCep"
                label="Cidade*"
                :rules="[rules.required]"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="distribuidor.dis_bairro"
                outlined
                :rules="[rules.required]"
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Bairro*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="distribuidor.dis_rua"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                :rules="[rules.required]"
                label="Rua*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0 pt-0">
              <v-text-field
                v-model="distribuidor.dis_numero"
                outlined
                :loading="salvando || loadingCep"
                :rules="[rules.required]"
                :disabled="salvando || loadingCep"
                label="Número*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="distribuidor.dis_complemento"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Complemento"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="distribuidor.dis_telefone"
                label="Telefone*"
                :loading="salvando"
                :rules="[rules.required]"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="distribuidor.dis_celular"
                label="Celular"
                :loading="salvando"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0 pb-0">
              <v-text-field
                v-model="distribuidor.dis_email"
                :rules="[rules.email]"
                label="E-mail"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="distribuidor.dis_imagem && !isObject(distribuidor.dis_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div>
                  <div class="ui-avatar" :style="`background-image: url('${distribuidor && distribuidor.dis_imagem ? distribuidor.dis_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagemDistribuidor = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
            <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="pt-0" v-else>
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="distribuidor.dis_imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(distribuidor.dis_imagem)"
                outlined
                :rules="[rules.size]"
                hint="Tamanho recomendado: 150x150px"
                persistent-hint
              ></v-file-input>
            </v-col>
            <!-- <v-col cols="12"
              sm="4"
              md="4"
              lg="4"
              xl="4"
              class="pt-0 mb-5"
            >
              <div class="ui-file-image-empresa">
                <span class="img_adicione" v-if="!url">Adicione a logomarca</span>
                <div v-if="url" class="ui-image--contain" :style="'background-image: url(' +url+ ')'"></div>
                <input type="file" class="file" @change="onFileChange" />
              </div>
            </v-col> -->
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditDistribuidor()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagemDistribuidor" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagemDistribuidor = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagemDistribuidor = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagemDistribuidor()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Distribuidor
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelDistribuidorDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Distribuidor <b class="text-primary">{{distribuidor ? distribuidor.dis_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelDistribuidorDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeDistribuidor()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogUsuarios"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Usuários
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="dialogNovoUsuario = true" color="primary" class="mr-3">Novo Usuário</v-btn>
              <v-icon @click="closeUsuariosLista()">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersUsuarios"
            :items="dadosUsuarios"
            :search="searchUsuarios"
            multi-sort
            fixed-header
            height="400px"
            :loading="loadingDistribuidorUsuarios"
            loading-text="Carregando... Por favor aguarde"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchUsuarios"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls('usuarios')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row no-gutters align="center" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openNovoUsuario(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteUsuarios(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="closeUsuariosLista()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirUsuario" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir usuário
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir usuário <b class="text-primary">{{usuario ? usuario.usu_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeUser()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovoUsuario"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{usuario.uuid_usu_id ? 'Editar' : 'Novo'}} usuário
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogUsuarios()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsuario">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" v-if="!$root.Permissions.integrator()">
              <v-switch
                hide-details
                class="ml-4 mt-0 mb-2"
                color="success"
                v-model="usuario.usu_permissao_publicidades"
                :loading="salvando"
                :disabled="salvando"
                label="Permite baixar pacotes de publicidades"
                :readonly="$root.Permissions.integrator()"
              ></v-switch>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usuario.uuid_gru_id"
                autofocus
                :items="modulos"
                clearable
                clear-icon="close"
                label="Grupo*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingGroups"
                :disabled="salvando || loadingGroups"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-text-field
                v-model="usuario.usu_nome"
                label="Nome*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="usuario.usu_email"
                label="E-mail*"
                :rules="[rules.required, rules.email]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="usuario.usu_apelido"
                label="Usuário*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field
                @click:append="show1 = !show1"
                :label="usuario.uuid_usu_id ? 'Preencha caso desejar alterar a senha' : 'Senha*'"
                hint="Mínimo 6 caracteres"
                counter
                outlined
                :loading="salvando"
                :disabled="salvando"
                :type="show1 ? 'text' : 'password'"
                v-model="usuario.password"
                :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                :rules="usuario.uuid_usu_id ? [] : [rules.required, rules.min]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="usuario.usu_imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(usuario.usu_imagem)"
                outlined
                :rules="[rules.size]"
                hint="Tamanho recomendado: 150x150px"
                persistent-hint
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="usuario.usu_imagem && !isObject(usuario.usu_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div>
                  <div class="avatar" :style="`background-image: url('${usuario && usuario.usu_imagem ? usuario.usu_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogUsuarios()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditUser()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
export default {
  components: {
    VueEditor
  },
  watch: {
    options: {
      handler () {
        this.getDistribuidores()
      },
      deep: true
    }
  },
  data () {
    return {
      total: 0,
      options: {},
      carregando: true,
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogUsuarios: false,
      dialogExcluir: false,
      dialogExcluirUsuario: false,
      dialogNovoUsuario: false,
      loadingCep: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      dialogDeletarImagem: false,
      loadingEstados: false,
      loadingCidades: false,
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
        size: value => !value || value.size < 10000000 || 'Imagem precisa ter menos que 10MB!',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'E-mail inválido.'
        }
      },
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'dis_id'
        },
        { text: 'Distribuidor', value: 'dis_nome' },
        { text: 'Nome fantasia', value: 'dis_nome_fantasia' },
        { text: 'Telefone', value: 'dis_telefone' },
        { text: 'Celular', value: 'dis_celular' },
        {
          text: 'Usuários',
          value: 'users',
          align: 'center',
          sortable: false,
          width: 60
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      searchUsuarios: '',
      headersUsuarios: [
        {
          text: 'ID',
          align: 'start',
          value: 'usu_id'
        },
        { text: 'Nome', value: 'usu_nome' },
        { text: 'E-mail', value: 'usu_email' },
        { text: 'Usuário', value: 'usu_apelido' },
        { text: 'Módulo', value: 'modulo' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosUsuarios: [],
      url: '',
      usuario: {
        uuid_gru_id: '',
        usu_permissao_publicidades: '',
        usu_nome: '',
        usu_email: '',
        usu_imagem: '',
        usu_apelido: '',
        password: ''
      },
      modulos: [],
      loadingDistribuidorUsuarios: false,
      distribuidorID: '',
      dialogDeletarImagemDistribuidor: false,
      distribuidor: {
        dis_nome: '',
        dis_nome_fantasia: '',
        dis_cnpj: '',
        dis_cep: '',
        dis_uf: '',
        dis_cidade: '',
        dis_bairro: '',
        dis_rua: '',
        dis_numero: '',
        dis_complemento: '',
        dis_telefone: '',
        dis_celular: '',
        dis_email: '',
        dis_imagem: ''
      }
    }
  },
  methods: {
    someHeader (model) {
      let cabecalhos = []
      model.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    async exportXls (type = null) {
      this.loadingXls = true
      Api.post('relatorios/exportar', {
        headers: this.someHeader(!type ? this.headers : this.headersUsuarios),
        distribuidor: this.distribuidorID,
        type: !type ? 'distribuidor' : 'distribuidor-usuarios',
        busca: !type ? this.search : this.searchUsuarios
      })
        .then(res => {
          this.downloadXls(res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    limparBusca () {
      this.search = null
      this.options.page = 1
      this.applyFilter()
    },
    applyFilter () {
      let query = Object.assign({},
        this.search ? { busca: this.search } : ''
      )

      this.$router.replace({name: this.$route.name, query: query}).catch(() => {})
      this.options.page = 1
      this.getDistribuidores()
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.busca) this.search = filters.busca

      this.getCidade()
      this.getEstados()
      this.getGroups()
    },
    isObject (val) {
      if (val && val !== '') {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getGroups () {
      this.loadingGroups = true
      await Api.get('grupos')
        .then(res => {
          var arrayGroups = []
          res.data.map(gru => {
            arrayGroups.push({
              'text': gru.gru_nome,
              'value': gru.uuid_gru_id
            })
          })
          this.modulos = arrayGroups
          this.loadingGroups = false
        })
        .catch(err => {
          this.loadingGroups = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os grupos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getDistribuidores () {
      this.carregando = true
      this.total = 0

      const { page, itemsPerPage } = this.options
      let pagina = 1
      let itensPagina = 1
      let endpoint = ''

      if (page) pagina = page
      if (itemsPerPage) itensPagina = itemsPerPage
      if (this.search) endpoint += `&busca=${this.search}`

      await Api.get(`distribuidores?page=${pagina}&per_page=${itensPagina}${endpoint}`)
        .then(res => {
          if (res.data) {
            let info = []
            if (res.data.data.length > 0) info = res.data.data

            this.total = res.data.total
            this.dados = info
          }
          this.carregando = false
          this.loading = false
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagemDistribuidor () {
      this.distribuidor.dis_imagem = ''
      this.distribuidor.remover_imagem = true
      this.dialogDeletarImagemDistribuidor = false
    },
    saveEditDistribuidor () {
      if (!this.$refs.formDistribuidor.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'distribuidores/novo'
      let editado = false
      if (this.distribuidor.uuid_dis_id) {
        endpoint = 'distribuidores/edita'
        editado = true
      }
      const formData = new FormData()
      Object.keys(this.distribuidor).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.distribuidor.dis_imagem[0].file)
            }
          }
        } else {
          if (this.distribuidor[key] != null) {
            formData.append(key, this.distribuidor[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Distribuidor atualizado com sucesso!' : 'Distribuidor cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getDistribuidores()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openDistribuidor (item) {
      this.salvando = true
      this.dialogNovo = true
      Api.get('distribuidores/' + item.uuid_dis_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.dis_uf) {
            this.filterCidade(response.data.dis_uf)
          }
          this.distribuidor = JSON.parse(JSON.stringify(response.data))
        })
        .catch((error) => {
          this.salvando = false
          this.dialogNovo = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro ao carregar dados do distribuidor!',
            color: 'error'
          })
        })
    },
    onFileChange (e) {
      this.distribuidor.logo = e.target.files[0]
      this.url = URL.createObjectURL(this.distribuidor.logo)
    },
    openDialogDelete (item) {
      this.distribuidor = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelDistribuidorDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    removeDistribuidor () {
      this.salvando = true
      Api.delete(`distribuidores/remove/${this.distribuidor.uuid_dis_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getDistribuidores()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover distribuidor!',
            color: 'error'
          })
        })
    },
    openUsuarios (item) {
      this.distribuidorID = item.uuid_dis_id
      this.dialogUsuarios = true
      this.getUsuariosDistribuidor()
    },
    async getUsuariosDistribuidor () {
      this.loadingDistribuidorUsuarios = true
      await Api.get('usuarios/distribuidor/' + this.distribuidorID)
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                usu_id: item.usu_id,
                usu_nome: item.usu_nome,
                usu_imagem: item.usu_imagem,
                usu_email: item.usu_email,
                usu_apelido: item.usu_apelido,
                modulo: item.grupo.gru_nome,
                uuid_gru_id: item.grupo.uuid_gru_id,
                uuid_usu_id: item.uuid_usu_id,
                usu_permissao_publicidades: item.usu_permissao_publicidades
              })
            })
            this.dadosUsuarios = info
          } else {
            this.dadosUsuarios = []
          }
          this.loadingDistribuidorUsuarios = false
        })
        .catch(err => {
          this.loadingDistribuidorUsuarios = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
          console.log(err)
        })
    },
    openNovoUsuario (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogNovoUsuario = true
    },
    cancelUsuarioDelete () {
      this.closeDialogUsuarios()
      this.dialogExcluirUsuario = false
    },
    removeImagem () {
      this.usuario.usu_imagem = ''
      this.usuario.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditUser () {
      if (!this.$refs.formUsuario.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usuarios/novo'
      let editado = false
      this.usuario.uuid_dis_id = this.distribuidorID
      if (this.$refs.file) {
        this.usuario.imagem = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.usuario).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.usuario.usu_imagem[0].file)
            }
          }
        } else if (key === 'usu_permissao_publicidades') {
          formData.append(`usu_permissao_publicidades`, this.usuario.usu_permissao_publicidades ? 1 : 0)
        } else {
          if (this.usuario[key] != null) {
            formData.append(key, this.usuario[key])
          }
        }
      })
      if (this.usuario.uuid_usu_id) {
        endpoint = 'usuarios/edita'
        editado = true
      }
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Usuário atualizado com sucesso!' : 'Usuário cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialogUsuarios()
          this.getUsuariosDistribuidor()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.msg : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeUser () {
      this.salvando = true
      Api.delete(`usuarios/remove/${this.usuario.uuid_usu_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.dialogExcluirUsuario = false
          this.salvando = false
          this.closeDialogUsuarios()
          this.getUsuariosDistribuidor()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover usuário!',
            color: 'error'
          })
        })
    },
    closeUsuariosLista () {
      this.distribuidorID = ''
      this.dadosUsuarios = []
      this.dialogUsuarios = false
    },
    openDialogDeleteUsuarios (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogExcluirUsuario = true
    },
    closeDialogUsuarios () {
      this.usuario = {
        uuid_gru_id: '',
        usu_nome: '',
        usu_imagem: '',
        usu_email: '',
        usu_apelido: '',
        password: ''
      }
      if (this.$refs.formUsuario) {
        this.$refs.formUsuario.resetValidation()
      }
      this.dialogNovoUsuario = false
    },
    closeDialog () {
      this.distribuidor = {
        dis_nome: '',
        dis_nome_fantasia: '',
        dis_cnpj: '',
        dis_cep: '',
        dis_uf: '',
        dis_cidade: '',
        dis_bairro: '',
        dis_rua: '',
        dis_numero: '',
        dis_complemento: '',
        dis_telefone: '',
        dis_celular: '',
        dis_email: '',
        dis_imagem: ''
      }
      if (this.$refs.formDistribuidor) {
        this.$refs.formDistribuidor.resetValidation()
      }
      this.dialogNovo = false
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.distribuidor.dis_rua = response.data.logradouro
              this.distribuidor.dis_bairro = response.data.bairro
              this.distribuidor.dis_complemento = response.data.complemento
              if (response.data.uf) {
                this.distribuidor.dis_uf = response.data.uf
                this.distribuidor.dis_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.max-height_dialog {
  overflow: auto;
  max-height: 400px;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 80px;
  margin-right: 15px;
  width: 80px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/gestor/Distribuidores.vue